import { Button } from "manifest-components/src/Button";
import { useState } from "react";

const Betterment = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const continueToBetterment = async () => {
    setLoading(true);
    window.location.replace(
      `${window.location.origin}/redirect/callback?partner=betterment&userId=6cc9e36f-0866-456d-a350-be49df7e15f4&transferId=30902`
    );
  };
  return (
    <Button
      text="Continue to Betterment"
      name="continueToBetterment"
      onClick={continueToBetterment}
      loading={loading}
    />
  );
};

export default Betterment;
